import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppResource } from 'src/app/app.resource';
import { PartnershipVM } from 'src/app/core/models/partnership.model';
import { Resource } from 'src/app/resources/resource';
import * as fromRoot from '../../../core/state/core.state';
import * as fromInfo from '../../../core/state/info';
import { PopUpInfoHAVM, PopUpInfoVM } from '../../models/components/popupinfoVm';
import { QuestionVM } from '../../models/components/questionVm';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss']
})
export class QuestionComponent implements OnInit {
  @Input() question!: QuestionVM;
  @Input() popupInfo?: PopUpInfoVM;
  @Input() popupInfoHA?: PopUpInfoHAVM;
  @Input() partnership?: PartnershipVM;
  @Input() local: boolean = false;

  logo!: string;
  resource: Resource;

  constructor(resources: AppResource, private readonly store: Store<fromRoot.State>) {
    this.resource = resources['resource'];
    this.logo = this.resource.question.logo;
  }

  ngOnInit() {
    if (!this.local) {
      this.store.select(fromInfo.selectCurrentQuestion).subscribe(res => {
        this.question = {
          libelle: res.libelle
        };
        this.popupInfo = res.popupInfo;
        this.partnership = res.partnership;
      });
    } else {
      this.question = this.question!;
      this.popupInfo = this.popupInfo!;
      this.popupInfoHA = this.popupInfoHA!;
      this.partnership = this.partnership!;
    }
  }
}
